import React, { useState, useEffect } from 'react';

const RecordList = () => {
  const [records, setRecords] = useState([]);

  useEffect(() => {
    const storedRecords = JSON.parse(localStorage.getItem('mentalRecords')) || [];
    setRecords(storedRecords);
  }, []);

  return (
    <div>
      <h2>記録一覧</h2>
      <ul>
        {records.map((record, index) => (
          <li key={index}>
            {new Date(record.date).toLocaleString()}: メンタル {record.mentalState}, 出来事: {record.event}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecordList; // 必ず「default」でエクスポート
